import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import IdpRoutes from './client/routes'
import Cookies from "universal-cookie";
import { API_SECRET_KEY, JWT_COOKIE_NAME } from "../src/client/constants/index";
import axios from "axios";
import { BASE_URL } from "../src/store/slices/urls";

const cookies = new Cookies();
// Config map
const appConfig = window.location.host.includes('careers360.net')
? {
  REACT_APP_API_URL: 'https://api.careers360.net',
  REACT_APP_MAIN_LOGIN_URL: 'https://www.careers360.net',
  REACT_APP_SUB_DOMAIN_NAME: '.careers360.net',
  REACT_APP_SESSION_DOMAIN_NAME: '.careers360.net'
}
: {
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  REACT_APP_MAIN_LOGIN_URL: process.env.REACT_APP_MAIN_LOGIN_URL,
  REACT_APP_SUB_DOMAIN_NAME: process.env.REACT_APP_SUB_DOMAIN_NAME,
  REACT_APP_SESSION_DOMAIN_NAME: process.env.REACT_APP_SESSION_DOMAIN_NAME,
};
axios.defaults.baseURL = BASE_URL;
axios.defaults.headers.common["x-api-key"] = API_SECRET_KEY;
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";
axios.defaults.timeout = 15000;
if (cookies.get(JWT_COOKIE_NAME + "_access")) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${cookies.get(
    JWT_COOKIE_NAME + "_access"
  )}`;
} else {
  axios.defaults.headers.common["Authorization"] = null;
}
axios.defaults.env.FormData = appConfig;

function App() {
  return (
    <div className="App">
      <IdpRoutes/>
    </div>
  );
}

export default App;
